import { useTranslation } from 'react-i18next'
import { Stack, Box, Button, Typography, TextField } from '@mui/material'
import { Info } from 'react-feather'
import { CustomTooltip } from '@/components'
import { ChosenFile } from '@/hooks'
import { SOUND_RECORD_DESCRIPTION_LENGTH } from '@/constants'

export type EntitySoundRecordProps = {
  soundRecord: ChosenFile
  onChange: (data: string) => void
  onDelete: () => void
  error?: string
}

export const SoundRecordUpload = ({
  soundRecord,
  onChange,
  onDelete,
  error,
}: EntitySoundRecordProps): JSX.Element => {
  const { t } = useTranslation()

  const notValidDescription =
    !soundRecord.description ||
    soundRecord.description.length < SOUND_RECORD_DESCRIPTION_LENGTH

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      borderRadius={1}
      px={3}
      py={2}
      bgcolor="grey.50"
    >
      <Typography mt={3}>{soundRecord.file.name}</Typography>
      <Stack direction="row" width={600}>
        <Box mt={3} mr={3}>
          <CustomTooltip
            placement="top-start"
            arrow={true}
            title="plek van opname, temperatuur, omgevingsfactoren (zoals riviertjes, slootjes, parken, bomenlanen, hoogbouw/laagbouw etc.), gedrag van de vleermuis (foerageren, invliegen, uitvliegen, etc.), omschrijving van de vleermuis, piekfrequentie van de vleermuis, en tot slot je eigen gedachte over de opname(s)!; wat denk je zelf dat het is?"
            onClick={(event) => event.stopPropagation()}
            maxWidth={500}
          >
            <Box
              mt={1}
              ml={1.5}
              sx={{
                cursor: 'pointer',
                ':hover': { svg: { color: 'green.500' } },
              }}
            >
              <Info size="16px" />
            </Box>
          </CustomTooltip>
        </Box>
        <TextField
          value={soundRecord.description}
          onChange={(event) => onChange(event.target.value)}
          label={t(
            'soundRecords:sound-record.fieldTitles.soundRecordFileDescription'
          )}
          fullWidth={true}
          multiline={true}
          inputProps={{
            style: {
              padding: 0,
            },
          }}
          error={!!error && notValidDescription}
          helperText={error && notValidDescription ? error : ''}
        />
      </Stack>
      <Box mt={2}>
        <Button
          onClick={onDelete}
          variant="contained"
          size="small"
          color="error"
        >
          {t('common:buttons.delete')}
        </Button>
      </Box>
    </Stack>
  )
}
